import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-_s4znoTgLu2pchKBiACawjrw8YfXywM",
  authDomain: "social-de-padel-project.firebaseapp.com",
  projectId: "social-de-padel-project",
  storageBucket: "social-de-padel-project.firebasestorage.app",
  messagingSenderId: "611728313878",
  appId: "1:611728313878:web:05e613ea37fc8836e6ef37",
  measurementId: "G-ES66FH8BRT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
